
const pcAdapt = () => {
    let topPhoneWrap = document.querySelector('#topPhoneWrap')
    let bottomPhoneWrap = document.querySelector('#bottomPhoneWrap')
    let ww = innerWidth
    const bp_lg = parseInt(window.getComputedStyle(topPhoneWrap).getPropertyValue('--xl'));
    if (ww <= bp_lg) { 
        let ph = document.querySelector('#topPhoneWrap .contactPhone')
        if (ph) {
            topPhoneWrap.removeChild(ph)
            bottomPhoneWrap.appendChild(ph)
        }
    } else {
        let ph = document.querySelector('#bottomPhoneWrap .contactPhone')
        if (ph) {
            bottomPhoneWrap.removeChild(ph)
            topPhoneWrap.appendChild(ph)
        }
    }
}

const orientationLock = async  () => {
    
    try {
        // alert(Math.min(innerHeight, innerWidth))
          if (Math.min(innerHeight,innerWidth) < 1000) {
            await screen.orientation.lock('portrait')
        }
        
    } catch (error) {
        console.log('could not lock orientation on this device')
    }
}





















window.addEventListener('load', ()=>{

    
    
    const nbMainCollapse = document.querySelector(".nbMain .navbar-collapse");
    const nbMain = document.querySelector(".nbMain");

    const config = { childList: true, subtree: true };
    const toggleNotification = () => {
        const notificationWrapper = document.querySelector("#notification-wrapper");
        notificationWrapper.children.length != 0 ? nbMainCollapse.classList.add('hasNotification') : nbMainCollapse.classList.remove('hasNotification')
    }
    const callback = (mutationList, observer) => {
       toggleNotification()
    };



    const observer = new MutationObserver(callback);
    observer.observe(nbMain, config);
    toggleNotification()
});

window.addEventListener('load', orientationLock);
window.addEventListener('load', pcAdapt);
window.addEventListener('resize', pcAdapt);